import {createActions} from '../../framework';

export default createActions(null, [
  'CLOSE_DROPDOWN',
  'OPEN_DROPDOWN',
  'RESET_STORE',
  'SET_SELECTED_ITEM',
  'SET_STORE_NAME'
]);
